"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardButtonSmall = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StandardButtonSmall = styled_components_1.default.button `
  user-select: none;

  background-image: linear-gradient(to top, #e0e0e0, white 60%);

  border-radius: 4px;
  border: 1px outset #ddd;
  padding: 4px 5px;

  font-size: 11px;

  cursor: pointer;

  &:hover {
    background: linear-gradient(to top, rgb(193, 217, 237), white 90%);
  }

  &:disabled {
    color: #888;
  }
`;
//# sourceMappingURL=standard-button-small.js.map